.searchItemContainer {
  width: 100%;
  display: flex;
  justify-content: stretch;
  align-items: flex-start;
  padding: 0.5rem;
  min-width: 0;
}
.searchItemContainer:not(:last-child) {
  border-bottom: 1px solid var(--static-divider-standard);
}

.searchItemContainer:hover {
  outline: 1px solid var(--static-divider-standard);
}

.minWidth0 {
  min-width: 0;
}

.listItemLeftColumn {
  width: 100%;
  min-width: 0;
  padding: 0 0.5rem;
}

.listItemRightColumn {
  min-width: 0;
  white-space: nowrap;
  min-width: max-content;
}

.listItemTitle {
  display: block;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
